var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chip-inner label__small",class:{
        danger: _vm.mode === 'danger',
        success: _vm.mode === 'success'}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }